import {GitHubAvatar} from '@github-ui/github-avatar'
import {graphql, useFragment} from 'react-relay'
import {Link} from '@primer/react'
import type {ParticipantFragment$key} from './__generated__/ParticipantFragment.graphql'
import {userHovercardPath} from '@github-ui/paths'

type ParticipantProps = {
  participant: ParticipantFragment$key
}

export function Participant({participant}: ParticipantProps) {
  const {login, avatarUrl} = useFragment(
    graphql`
      fragment ParticipantFragment on User {
        login
        avatarUrl(size: 64)
      }
    `,
    participant,
  )
  return (
    <Link href={`/${login}`}>
      <GitHubAvatar
        src={avatarUrl}
        size={20}
        alt={`@${login}`}
        data-hovercard-url={userHovercardPath({owner: login})}
        sx={{boxShadow: '0 0 0 2px var(--bgColor-muted, var(--color-canvas-subtle))'}}
      />
    </Link>
  )
}

try{ Participant.displayName ||= 'Participant' } catch {}